import Modal from 'components/commons/modal/Modal2';
import React from 'react';
import { AssetTypeKey, assetTypeKeyToString } from '../utils/assetType';
import { AssetType } from 'config/consts';

export const WhatIsIncludeAsstsModal = ({
  hideModal,
  isShowModal,
  assetTypeKey,
}: {
  isShowModal: boolean;
  hideModal: () => void;
  assetTypeKey: AssetTypeKey;
}): React.ReactElement => {
  const title = assetTypeKeyToString(assetTypeKey);

  return (
    <>
      <Modal {...{ isShow: isShowModal, close: hideModal }}>
        <div className={`ui-border-b flex flex-col pt-4`}>
          <div className="flex flex-row pb-4 px-4">
            <div className={`text-bluegray-700 font-bold text-base`}>
              {title}に含まれる資産
            </div>
            <div
              className={`icon-close text-bluegray-400 ml-auto text-lg cursor-pointer`}
              onClick={hideModal}></div>
          </div>
          <div className={`px-4 pb-2 text-sm text-bluegray-500`}>
            <div className={``}>
              {(() => {
                switch (assetTypeKey) {
                  case AssetType['預金_MRF']:
                    return (
                      <>
                        <div>・預り金</div>
                        <div>・MRF</div>
                      </>
                    );
                  case AssetType['その他']:
                    return (
                      <>
                        <div>総資産から下記５つを除いたものになります。</div>
                        <div>・国内株式（現物）</div>
                        <div>・国内株式（信用）</div>
                        <div>・投資信託</div>
                        <div>・外国株式（現物）</div>
                        <div>・現金</div>
                      </>
                    );
                }
              })()}
            </div>
            <div className={`mt-4`}>
              {(() => {
                switch (assetTypeKey) {
                  case AssetType['預金_MRF']:
                    return '手入力で資産を入力する際に種別を「預金・MRF」へ手動で設定した場合は、手入力した資産が表示されます。';
                  case AssetType['その他']:
                    return '手入力で資産を入力する際に種別を「その他」へ手動で設定した場合は、手入力した資産が表示されます。';
                }
              })()}
            </div>
          </div>
          <button
            onClick={hideModal}
            className={`bg-white p-4 px-8 text-bluegray-500 text-sm flex justify-center items-center`}>
            閉じる
          </button>
        </div>
      </Modal>
    </>
  );
};
